// Make non-https links absolute
export function getValidUrl(url) {
  if (!/^(f|ht)tps?:\/\//i.test(url)) {
    return `https://${url}`;
  }

  return url;
}



// WEBPACK FOOTER //
// ./app/javascript/client/editor-core/utils/url.js